var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPyusd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 84.3 84.9",
    style: {
      enableBackground: "new 0 0 84.3 84.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0071F3;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.1,84.9c23.3,0,42.1-19,42.1-42.4C84.3,19,65.4,0,42.1,0C18.9,0,0,19,0,42.4C0,65.9,18.9,84.9,42.1,84.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.8,17h-4.6H34c-1.6,0-3.1,1.2-3.3,2.9l-1,6.8v0.1h-5c-1.3,0-2.4,1.1-2.4,2.4c0,1.4,1.1,2.4,2.4,2.5h4.2 l-0.7,4.7l0,0.4h-5c-1.3,0-2.4,1.1-2.4,2.4c0,1.3,1.1,2.4,2.4,2.4h4.2l-2.3,14.6l-0.7,4.9l-0.4,2.6c-0.3,2.1,1.2,3.9,3.3,3.9h3.2 h4.4h3.6c1.6,0,3-1.2,3.3-2.9l2.1-13.4h1.2h4c9.4,0,17.1-7.8,16.9-17.3C65.9,24.3,58.1,17,48.8,17z M33.8,31.5l15,0.1 c1.3,0,2.5,1.1,2.5,2.5c0,1.4-1.1,2.5-2.5,2.5H33L33.8,31.5z M48.9,46.1h-2.5h-1.2h-2.5c-1.6,0-3,1.2-3.3,2.9l-2.1,13.4H29l3.2-21 h16.6c4,0,7.3-3.3,7.3-7.3c0-4-3.3-7.3-7.3-7.3l-14.2-0.1l0.7-4.8h13.8c6.8,0,12.2,5.6,12.1,12.4C61,40.9,55.5,46.1,48.9,46.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPyusd);
export default __webpack_public_path__ + "static/media/pyusd.967e190ef1dfe98eb27b7bdb1ee90b4c.svg";
export { ForwardRef as ReactComponent };